import { render } from "./HeroiconsSolidChevronUp.vue?vue&type=template&id=20b1126c"
const script = {}

import exportComponent from "/home/malezha/zfort/digitalfax/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidChevronUp.vue"]])

export default __exports__